import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import {
  ConsultaSeguimentoAplicacaoItemModel,
  ConsultaSeguimentoAplicacaoModel,
  ConsultaSeguimentoPerguntaStatusEnum,
} from './model-consultaSeguimento'

export function isConsultaSeguimentoPerguntaStatusRespondendo(status: ConsultaSeguimentoPerguntaStatusEnum): boolean {
  return [
    ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO,
    ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU,
    ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU,
  ].includes(status)
}

export function getConsultaSeguimentoAplicacaoPerguntaAtiva(
  aplicacao: ConsultaSeguimentoAplicacaoModel
): {
  pergunta: MChatPerguntaEnum
  value: ConsultaSeguimentoAplicacaoItemModel
} {
  const perguntaAtiva = Object.entries(aplicacao).find(([_, value]) =>
    isConsultaSeguimentoPerguntaStatusRespondendo(value.status)
  ) as [MChatPerguntaEnum, ConsultaSeguimentoAplicacaoItemModel]

  const [pergunta, value] = perguntaAtiva ?? []

  return {
    pergunta,
    value,
  }
}

export function getConsultaSeguimentoAplicacaoPerguntaNextStatus(
  status: ConsultaSeguimentoPerguntaStatusEnum
): ConsultaSeguimentoPerguntaStatusEnum {
  if (status === ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU) {
    return ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_FALHOU
  }
  if (status === ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU) {
    return ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_PASSOU
  }
  return null
}

export function getConsultaSeguimentoAplicacaoPerguntaPrevStatus(
  status: ConsultaSeguimentoPerguntaStatusEnum
): ConsultaSeguimentoPerguntaStatusEnum {
  if (
    status === ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO ||
    status === ConsultaSeguimentoPerguntaStatusEnum.DISPONIVEL
  ) {
    return ConsultaSeguimentoPerguntaStatusEnum.DISPONIVEL
  }
  if (status === ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU) {
    return ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_FALHOU
  }
  if (status === ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_FALHOU) {
    return ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_FALHOU
  }
  if (status === ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU) {
    return ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_PASSOU
  }
  if (status === ConsultaSeguimentoPerguntaStatusEnum.FINALIZADO_PASSOU) {
    return ConsultaSeguimentoPerguntaStatusEnum.RESPONDENDO_PASSOU
  }
  return ConsultaSeguimentoPerguntaStatusEnum.NAO_DISPONIVEL
}

export const hasAnyNao = <T extends string>(value: Record<T, SimNaoEnum>): boolean => {
  if (isEmpty(value)) return false
  return Object.values(value).some((item) => item === SimNaoEnum.NAO)
}

export const hasAnySim = <T extends string>(value: Record<T, SimNaoEnum>): boolean => {
  if (isEmpty(value)) return false
  return Object.values(value).some((item) => item === SimNaoEnum.SIM)
}

export const isAllNao = <T extends string>(value: Record<T, SimNaoEnum>, expected: T[]): boolean => {
  if (!value || !expected || isEmpty(expected)) return false

  return expected.every((campo) => value[campo] === SimNaoEnum.NAO)
}
